<template>
    <v-container fluid>
        <filtro ref="filtro" @filtrar="filtrar" @fornecedor-change="onFornecedorChange"></filtro>
        <v-card class="my-4 px-2 br-15" elevation="0">
            <v-row no-gutters>
                <v-col cols="8" class="px-4 py-4">
                    <div class="detalhes">
                        <span>Fornecedor:</span
                        ><span class="grey--text">
                            {{ resumo.fornecedor }}
                        </span>
                        <br />
                        <span>Mês: </span>
                        <span class="grey--text"> {{ resumo.periodo }} </span>
                        <br />
                    </div>
                </v-col>
                <v-col cols="4" align="end" class="py-2 d-flex justify-end">
             <v-btn
                        color="primary"
                        class="new-button px-8 mr-2 mt-4"
                        
                        @click="enviarEmailFornecedor()"
                        :disabled="!fornecedorSelecionado"
                        :loading="enviandoEmail"
                    >
                        <v-icon left>mdi-email-outline</v-icon>
                        Enviar extrato por e-mail
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="new-button px-8 mr-4 mt-4"
                        
                        :disabled="!fornecedorSelecionado"
                        @click="extratoXLSX()"
                    >
                        <v-icon left>mdi-microsoft-excel</v-icon>
                        Exportar XLSX
                    </v-btn>
                </v-col>
            </v-row>
            <v-divider class="mx-4"></v-divider>
            <v-row class="mx-1 my-2 mb-3 mt-3">
                <v-col cols="4">
                    <Indicadores
                        titulo="E-commerce"
                        :valor="resumo.investimentoEcommerce"
                        icone="mdi-cart-outline"
                        :load="false"
                    />
                </v-col>
                <v-col cols="4">
                    <Indicadores
                        titulo="Planejamento"
                        :valor="resumo.investimentoPlanejamento"
                        icone="mdi-calendar-check-outline"
                        :load="false"
                    />
                </v-col>
                <v-col cols="4">
                    <Indicadores
                        titulo="Total"
                        :valor="resumo.total"
                        icone="mdi-currency-usd"
                        :load="false"
                    />
                </v-col>
            </v-row>
        </v-card>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 400"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">
                Fechar
            </v-btn>
        </v-snackbar>
        <v-dialog
            :persistent="porcentagem < 100"
            content-class="br-15"
            v-model="dialog"
            width="600"
            style="z-index: 5000"
        >
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title> Exportando Extrato XLSX </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="porcentagem < 100"
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialog = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <p class="text-center">
                        {{ mensagemProcessamento }}
                        <span v-if="!erroProcessamento"
                            >({{ porcentagem }}%)</span
                        >
                    </p>
                    <v-progress-linear
                        class="mb-3"
                        :color="erroProcessamento ? 'error' : 'teal'"
                        buffer-value="0"
                        :value="porcentagem"
                        stream
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Filtro from "./Filtro.vue";
import Indicadores from "./_components/Indicadores.vue";

export default {
    components: {
        Filtro,
        Indicadores,
    },
    data() {
        return {
            dialog: false,
            carregando: false,
            enviandoEmail: false,
            erroProcessamento: false,
            fornecedorSelecionado: false,
            dadosVerba: [],
            headersVerba: [
                { text: "Acor.", value: "id_acordo", align: "center" },
                { text: "Acor. RD", value: "acordo_rd", align: "center" },
                { text: "Bandeira", value: "bandeira", align: "center" },
                {
                    text: "Cod. Forn.",
                    value: "codigo_fornecedor",
                    align: "center",
                },
                { text: "Fornecedor", value: "fornecedor", align: "center" },
                { text: "Cluster", value: "cluster", align: "center" },
                { text: "Cod. Esp.", value: "codigo_espaco", align: "center" },
                { text: "Espaço", value: "espaco", align: "center" },
                { text: "Desc.", value: "desconto", align: "center" },
                {
                    text: "Desc. %",
                    value: "desconto_percentual",
                    align: "center",
                },
                { text: "Invest.", value: "investimento", align: "center" },
                { text: "Valor s/ Desc.", value: "valor", align: "center" },
                { text: "Mês", value: "mes", align: "center" },
                { text: "Filiais", value: "filiais", align: "center" },
                { text: "Produtos", value: "produtos", align: "center" },
                { text: "Status", value: "status", align: "center" },
                {
                    text: "Obs. Depart.",
                    value: "obs_departamento",
                    align: "center",
                },
            ],
            paginationVerba: {},
            totalVerba: null,
            dadosVB: [],
            headersVB: [
                { text: "Acor.", value: "id_acordo", align: "center" },
                { text: "Acor. RD", value: "acordo_rd", align: "center" },
                { text: "Mês", value: "mes", align: "center" },
                { text: "Bandeira", value: "bandeira", align: "center" },
                { text: "ID JAVA", value: "id_java", align: "center" },
                { text: "CNPJ", value: "cnpj", align: "center" },
                { text: "Filial", value: "filial", align: "center" },
                { text: "Cluster", value: "cluster", align: "center" },
                {
                    text: "Cod. Prod.",
                    value: "codigo_produto",
                    align: "center",
                },
                { text: "Produto", value: "produto", align: "center" },
                { text: "Espaço", value: "espaco", align: "center" },
                {
                    text: "Cod. Forn.",
                    value: "codigo_fornecedor",
                    align: "center",
                },
                { text: "Fornecedor", value: "fornecedor", align: "center" },
                { text: "VB", value: "vb", align: "center" },
            ],
            paginationVB: {},
            totalVB: null,
            porcentagem: 0,
            mensagemProcessamento: "",
            resumo: {
                fornecedor: null,
                periodo: null,
                investimentoEcommerce: null,
                investimentoPlanejamento: null,
                total: null,
            },
            alerta: false,
            alertaTexto: "",
            alertaColor: "error",
            alertaTimeout: 3000,
        };
    },


    methods: {
        onFornecedorChange(hasFornecedor) {
            this.fornecedorSelecionado = hasFornecedor;
        },

        async filtrar2() {
            await this.$http().post(
                "/planejamento/testeXLSX",
                {},
                {
                    // params: data,
                    onDownloadProgress: (progressEvent) => {
                        const retorno =
                            progressEvent.currentTarget.response.split("\n");
                        console.log(progressEvent);
                        this.teste = retorno[retorno.length - 2];

                        // let _i =
                        //     retorno.length > 1 ? retorno.length - 2 : 0;
                        // let obj = JSON.parse(retorno[_i]);

                        // // this.index = obj.index || 0;
                        // console.log(obj)
                        // if (obj.url) {
                        //     url = obj.url;
                        // }

                        // if (obj.msg) msgError = obj.msg;
                    },
                }
            );
        },

        async filtrar(tipo = "tudo") {
            this.carregando = true;

            var filtro = { ...this.$refs.filtro.filtro };

            var data = {};

            data.mesInicial = filtro.mesInicial;
            data.mesFinal = filtro.mesInicial;
            data.id_fornecedor = filtro.id_fornecedor;

            if (tipo == "tudo") {
                this.paginationVerba.page = 1;
                this.paginationVB.page = 1;
            }

            data.paginationVerba = this.paginationVerba;
            data.paginationVB = this.paginationVB;

            data.tipo = tipo;

            var response = await this.$http().post("/planejamentoEcommerce/extratoEcommerce/extrato", {
                data: data,
            });

            // Atualiza estado do botão de enviar email
            this.fornecedorSelecionado = data.id_fornecedor && data.id_fornecedor.length > 0;

            if (response.data && response.data.success && response.data.data) {
                const dados = response.data.data;
                
                // Pega o nome do fornecedor selecionado
                const fornecedorSelecionadoNome = this.$refs.filtro.lista.fornecedor?.find(
                    f => data.id_fornecedor.includes(f.value)
                );
                
                this.resumo = {
                    fornecedor: fornecedorSelecionadoNome?.text || 
                                (data.id_fornecedor.length > 1 
                                    ? `${data.id_fornecedor.length} fornecedores selecionados` 
                                    : 'Fornecedor'),
                    periodo: this.$moment(data.mesInicial + "-01").format("MMM/YYYY"),
                    investimentoEcommerce: dados.totalEcommerce || "R$ 0,00",
                    investimentoPlanejamento: dados.totalPlanejamento || "R$ 0,00",
                    total: dados.totalGeral || "R$ 0,00",
                };
            } else {
                this.resumo = {
                    fornecedor: null,
                    periodo: null,
                    investimentoEcommerce: null,
                    investimentoPlanejamento: null,
                    total: null,
                };
            }

            this.carregando = false;
        },
        async enviarEmailFornecedor() {
            if (!this.$refs.filtro.validate()) return;
            this.carregando = true;
            this.enviandoEmail = true;

            try {
                var filtro = { ...this.$refs.filtro.filtro };

                var data = {};

                data.mesInicial = filtro.mesInicial;
                data.mesFinal = filtro.mesInicial;
                data.id_fornecedor = filtro.id_fornecedor;
                data.api = this.$http("baseURL");

                var response = await this.$http().post(
                    "/planejamentoEcommerce/extratoEcommerce/enviarEmailFornecedor",
                    { data: data }
                );

                // Suporta tanto 'sucesso' quanto 'success'
                const isSuccess = response.data && (response.data.sucesso === true || response.data.success === true);

                if (isSuccess) {
                    this.alerta = true;
                    this.alertaColor = "success";
                    this.alertaTimeout = 5000;
                    this.alertaTexto = response.data.msg || response.data.message || "E-mail enviado com sucesso!";
                } else {
                    this.alerta = true;
                    this.alertaColor = "error";
                    this.alertaTimeout = 5000;
                    this.alertaTexto = response.data?.msg || response.data?.message || "Erro ao enviar e-mail. Tente novamente.";
                }
            } catch (error) {
                this.alerta = true;
                this.alertaColor = "error";
                this.alertaTimeout = 5000;
                this.alertaTexto = "Erro ao enviar e-mail. Tente novamente.";
            } finally {
                this.enviandoEmail = false;
                this.carregando = false;
            }
        },
        async extratoXLSX() {
            if (!this.$refs.filtro.validate()) return;
            this.erroProcessamento = false;
            // if (this.totalVB > 200000 || this.totalVerba > 200000) {
            //     this.alerta = true;
            //     this.alertaColor = "error";
            //     this.alertaTimeout = -1;
            //     this.alertaTexto =
            //         "Não é permitido exportação de extrato XLSX com mais de 200.000 linhas. Utilize os filtros para dividir a exportação, ou exporte como CSV.";
            //     return;
            // }

            // this.carregando = true;
            this.dialog = true;

            var filtro = { ...this.$refs.filtro.filtro };

            var data = {};

            data.mesInicial = filtro.mesInicial;
            data.mesFinal = filtro.mesInicial;
            data.id_fornecedor = filtro.id_fornecedor;

            data.periodo = this.$moment(data.mesInicial + "-01").format(
                "MMM/YYYY"
            );

            var response = await this.$http().post(
                "/planejamentoEcommerce/extratoEcommerce/extratoXLSX",
                {
                    data: data,
                },
                {
                    onDownloadProgress: (progressEvent) => {
                        const retorno =
                            progressEvent.currentTarget.response.split("\n");
                        console.log(progressEvent);
                        const data = JSON.parse(retorno[retorno.length - 2]);
                        console.log(data);
                        this.porcentagem = data.porcentagem || 0;
                        
                        // Suporta tanto 'sucesso' quanto 'success'
                        const isSuccess = data.sucesso !== false && data.success !== false;
                        
                        // Define a mensagem (suporta 'msg', 'mensagem' ou 'message')
                        this.mensagemProcessamento = data.msg || data.mensagem || data.message || "Processando...";
                        
                        // Verifica se houve erro
                        if (!isSuccess || data.error) {
                            this.erroProcessamento = true;
                            this.porcentagem = 100;
                        }
                        
                        // Se tem URL, faz o download
                        if (data.url) {
                            window.location = this.$http("baseURL") + data.url;
                        }
                        
                        // Se sucesso e não tem URL (enviado por e-mail), marca como completo
                        if (isSuccess && !data.url && this.porcentagem === 0) {
                            this.porcentagem = 100;
                        }
                    },
                }
            );
            console.log(response);
            if (response.status !== 200) {
                this.mensagemProcessamento =
                    "Erro ao gerar o arquivo. Tente novamente.";
                this.porcentagem = 100;
                this.erroProcessamento = true;
            }
            this.carregando = false;
        },
    },
};
</script>


<style>
.detalhes {
    font-weight: 500;
}
</style>
